var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.$store.getters.isAuthenticated)?_c('nav',{attrs:{"data-cy":"main-nav"}},_vm._l((_vm.navLinks),function(link){return _c('NavigationItem',{key:link.label,attrs:{"linkData":link},on:{"closeMenu":function($event){return _vm.$emit('closeMenu')}}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }